import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createOteConType = ( {data} : {data: IPostNewOteConType | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/OteConTypes/InsertOteConType`, data);
};

type QueryFnType = typeof createOteConType;

type UseCreateOteConTypeOptions = {
  data: IPostNewOteConType | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateOteConType = ({ config }: UseCreateOteConTypeOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Είδους γραμμής ΟΤΕ.`, 500);
            console.error('Couldnt create new OteCon ', error);
            setIsNotificationVisible(true)
          },
          onSuccess: (response) => {
            queryClient.invalidateQueries(["getAllOteConTypes"])
            addNotification("Δημιουργήθηκε Νέο Είδος γραμμής ΟΤΕ.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createOteConType,
    })
}